<div class="Txt-Inbox">
  <h2>{{ this.subject }}</h2>
  <span>{{ 'inbox-desc' | t }}</span>

  <!--<div>
    <button mat-flat-button color="primary" class="inbox-messages-button" style="width:100%;margin-bottom: 8px;margin-top: 8px;" (click)="openDialog()">New Message</button>
  </div>-->

  <div style="display: inline-block; margin-top: 8px; width: 100%">
    <mat-card
      *ngFor="let item of this._DataHelper.DataCustomerTicketDetailList"
      [ngClass]="{ 'inbox-ticketdetail-answer-admin': item.ReplyUser === 'Administrator', 'inbox-ticketdetail-answer-user': item.ReplyUser !== 'Administrator' }">
      <div style="width: 100%; margin-bottom: 6px; height: 14px">
        <div
          style="width: 60%; float: left; font-size: 14px; font-weight: bold"
          [ngClass]="{ 'inbox-reply-admin': item.ReplyUser === 'Administrator', 'inbox-reply-user': item.ReplyUser !== 'Administrator' }">
          {{ item.ReplyUser }}
        </div>
        <div style="width: 40%; float: left; text-align: right; font-size: 12px">{{ item.CreateDateISO | dateFormatDistance }}</div>
      </div>
      <mat-card-content>
        <div *ngIf="item.UploadFile !== ''">
          <img mat-card-image src="{{ item.UploadFile }}" style="margin: 0px" alt="İmage" />
          <!--background-size:cover;height:140px;width:100%;-->
        </div>
      </mat-card-content>
      <mat-card-content style="margin-bottom: 0px">
        <p>
          {{ item.Answer }}
        </p>
      </mat-card-content>

      <mat-card-content style="margin-bottom: 0px; text-align: right" *ngIf="item.ReplyUser !== 'Administrator' && item.IsRead == true">
        <image-loader-utils url="check-double" extraClasses="check-double-icon"></image-loader-utils>
        <image-loader-utils url="check-double" extraClasses="check-double-icon"></image-loader-utils>
      </mat-card-content>
    </mat-card>

    <button mat-fab style="position: fixed; background-color: #ed1c24; bottom: 70px; right: 10px" class="ticketdetail-new-message-button" (click)="openDialog()">+</button>
  </div>
</div>
